export default __webpack_public_path__ + "static/media/android.12380540.png";